// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__gCoI8","description":"NotFoundBlock_description__FedGB"};